import React from 'react';
import { Box, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import colors from '../../assets/theme/colors';
import CustomJourneySupportingLink from './CustomJourneySupportingLink';

const CustomJourneyOverviewDetails = ({
  answers = [], revisionStatus, reviewedPeriodText, accent, onReviewSupporting,
  gathering = false, gatheringFailed = false,
}) => {
  const hasConfirmedAnswer = answers.some((answer) => (
    answer.status === 'confirmed' && String(answer.confirmedText || '').trim()
  ));
  const status = gathering
    ? 'Gathering information'
    : gatheringFailed
      ? 'Showing previously saved information'
      : revisionStatus?.hasFinalizedRevision && !revisionStatus?.changedSinceFinalized
        ? 'Brief finalized'
        : hasConfirmedAnswer
          ? 'Ready to finish'
          : 'Ready to review';
  const statusDetail = gathering
    ? 'Lifelog is reviewing the records. You can look around, but suggestions may still change.'
    : gatheringFailed
      ? "Lifelog couldn't check for updates right now."
      : '';

  return (
    <>
      <Typography role="status" sx={{ mt: 0.65, fontSize: '0.82rem', fontWeight: 750, color: accent.ink }}>
        {status}
      </Typography>
      {statusDetail ? (
        <Typography sx={{ mt: 0.25, fontSize: '0.8rem', lineHeight: 1.4, color: alpha(colors.semantic.ink, 0.62) }}>
          {statusDetail}
        </Typography>
      ) : null}
      <Typography sx={{ mt: 0.55, fontSize: '0.84rem', color: alpha(colors.semantic.ink, 0.62) }}>
        {reviewedPeriodText || 'Lifelog reviewed the information available for this preparation.'}
      </Typography>
      <Box sx={{ mt: 1.2 }}>
        <CustomJourneySupportingLink accent={accent} onClick={onReviewSupporting} />
      </Box>
    </>
  );
};

export default CustomJourneyOverviewDetails;
